export const MESI = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

/**
 * Tendina "Mese" per le barre filtri delle liste (Sopralluoghi, Attivazioni,
 * Interventi). `undefined` = "Tutti i mesi". L'anno viene assunto quello
 * corrente lato backend, non serve una seconda tendina.
 */
export function MeseSelect({
  value,
  onChange,
  className = "h-10 rounded-lg border border-line bg-white px-3 text-sm text-ink",
}: {
  value: number | undefined;
  onChange: (mese: number | undefined) => void;
  className?: string;
}) {
  return (
    <select
      aria-label="Filtra per mese"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : undefined)}
      className={className}
    >
      <option value="">Tutti i mesi</option>
      {MESI.map((m, i) => (
        <option key={i + 1} value={i + 1}>
          {m}
        </option>
      ))}
    </select>
  );
}
